import dunegql from "src/utils/dunegqlCodegen/dunegql";
import {
  TrackFirstVisualizationCreatedMutation,
  useTrackFirstVisualizationCreatedMutation,
} from "../codegen/duneGraphql";
import type { Session } from "src/utils/users/types";
import { useGetCreatorOnboardingChecklist } from "./useGetCreatorOnboardingChecklist";
import { MutationResult } from "@apollo/client";

export function useTrackFirstVisualizationCreated(
  session?: Session
): [() => void, MutationResult<TrackFirstVisualizationCreatedMutation>] {
  const checklist = useGetCreatorOnboardingChecklist(session);
  const [mutation, res] = useTrackFirstVisualizationCreatedMutation({
    context: { session },
    variables: {
      userId: session!.user!.id,
    },
  });
  const shouldTrackVizCreated =
    session?.user !== undefined &&
    checklist !== undefined &&
    checklist.visualizationCreatedAt === null;

  return [shouldTrackVizCreated ? mutation : () => {}, res];
}

dunegql`
mutation TrackFirstVisualizationCreated($userId: Int!) {
  trackFirstVisualizationCreated(userId: $userId) {
    dismissedAt
    querySavedAt
    userId
    visualizationCreatedAt
    visualizationSharedAt
  }
}
`;
